<template>
    <div>
        <div class='panBody'>
            <el-card shadow="hover">

                <span class="label-span">
                    <label class="label">日期范围</label>
                    <!--                    <el-date-picker v-model="query.startDay" value-format="yyyy-MM-dd" style="width:142px;" type="date"-->
                    <!--                                    placeholder="开始日期"></el-date-picker>-->
                    <!--                    <el-date-picker class="mr10" v-model="query.endDay" value-format="yyyy-MM-dd" style="width:143px;"-->
                    <!--                                    type="date" placeholder="截止日期"></el-date-picker>-->

                     <el-date-picker v-model="query.startDay" :picker-options="pickerOptions1"
                                     value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;" type="datetime"
                                     placeholder="开始时间"></el-date-picker>
                    <el-date-picker v-model="query.endDay" :picker-options="pickerOptions2"
                                    value-format="yyyy-MM-dd HH:mm:ss" style="width:160px;margin-right:10px;"
                                    type="datetime" placeholder="结束时间"></el-date-picker>

                </span>
<!--                <span class="label-span">-->
<!--                    <label class="label">订购指标</label> -->
<!--                    <el-select v-model="query.status2" multiple placeholder="订单状态,可多选" filterable clearable-->
<!--                               class="mr10" style="width:285px;">-->

<!--                        <el-option value="5" label="回填成功" />-->
<!--                        <el-option value="-1" label="订购失败" />-->
<!--                        <el-option value="9" label="订购成功" />-->
<!--                    </el-select>  -->
<!--                </span>-->
                <span class="label-span">
                    <label class="label">上游资源</label> 
                    <el-select class="mr10" v-model="query.channelCode2" multiple placeholder="资源名称"
                               style="width:285px;"
                               filterable clearable>
                        <el-option value="" label="所有资源" />
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">系统产品</label> 
                     <el-select v-model="query.goodsId2" multiple placeholder="产品名称，可多选" filterable
                                clearable style="width:285px;" class=" mr10">
                        <el-option value="" label="所有产品" />
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal"
                                   :value="item.optVal" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">下游渠道</label> 
                    <el-select v-model="query.mids2" placeholder="下游渠道" multiple filterable clearable class="mr10"
                               style="width:285px">
                        <el-option value="" label="所有渠道" />
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select> 
                </span>
                <span class="label-span">
                    <label class="label">剔除扣量</label> 
                    <el-select v-model="query.isDeduction" placeholder="剔除扣量" filterable class="mr10"
                               style="width:120px">
                        <el-option value="0" label="不剔除" />
                        <el-option value="1" label="已剔除" />
                    </el-select>
                </span>
                <el-button type="success" icon="el-icon-search" class="mr10" @click="handleSearchDataBody3">查询
                </el-button>
            </el-card>
            <el-card shadow="hover" style="margin-top:5px;">
                <div class='table1'>
                    <h3  class="table-title">请求量：{{query.startDay.substring(0,10)}} ～ {{query.endDay.substring(0,10)}}</h3>
                    <el-table
                        v-loading="loading"
                        :data="tableTData" border
                        row-key="superiorId"
                        size="mini"
                        show-summary
                        :highlight-current-row="true">


                        <el-table-column
                            fixed="left"
                            v-for="(col, index) in tableTColumns"

                            :key="col.prop"
                            :prop="col.prop"
                            :label="col.label"
                            :fixed="index === 0 ? 'left' : false"
                            :min-width="index === 0 ? '220' : '130'"
                            :align="index === 0 ? 'left' : 'center'">
                            <template slot-scope="{ $index, row }">
                                <!-- 判断是否是最后一列（统计列） -->
                                <el-link
                                    v-if="col.prop !== '¶ 统计' && col.prop !== '产品名称'  "
                                    @click.native="handleCellClick(row, col)">
                                    {{ row[col.prop] }}
                                </el-link>
                                <span v-else
                                      :style="{ color: typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#') ? 'red' : '' }">
  {{
                                        typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#')
                                            ? row[col.prop].substring(4)
                                            : row[col.prop]
                                    }}
</span>
                            </template>

                        </el-table-column>
                    </el-table>
                    <!-- 添加 5 个空白 div 撑开高度 -->
                    <!--                    <div style="height: 20px;" v-for="n in 2" :key="n"></div>-->
                </div>
            </el-card>

            <el-card shadow="hover" style="margin-top:5px;">
                <div class='table1'>
                    <h3  class="table-title">订购量：{{query.startDay.substring(0,10)}} ～ {{query.endDay.substring(0,10)}}</h3>
                    <el-table
                        v-loading="loading"
                        :data="tableData" border
                        row-key="superiorId"
                        size="mini"
                        show-summary
                        :highlight-current-row="true">


                        <el-table-column
                            fixed="left"
                            v-for="(col, index) in tableColumns"

                            :key="col.prop"
                            :prop="col.prop"
                            :label="col.label"
                            :fixed="index === 0 ? 'left' : false"
                            :min-width="index === 0 ? '220' : '130'"
                            :align="index === 0 ? 'left' : 'center'">
                            <template   slot-scope="{ $index, row }">
                                <!-- 判断是否是最后一列（统计列） -->
                                <el-link
                                    v-if="col.prop !== '¶ 统计' && col.prop !== '产品名称'  "
                                    @click.native="handleCellClick(row, col)">
                                    {{ row[col.prop] }}
                                </el-link>
                                <span v-else :style="{ color: typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#') ? 'red' : '' }">
  {{
                                        typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#')
                                            ? row[col.prop].substring(4)
                                            : row[col.prop]
                                    }}
</span>
                            </template>

                        </el-table-column>
                    </el-table>
                    <!-- 添加 5 个空白 div 撑开高度 -->
<!--                    <div style="height: 20px;" v-for="n in 2" :key="n"></div>-->
                </div>
            </el-card>

            <el-card shadow="hover" style="margin-top:5px;">
                <div class='table1'>
                    <h3  class="table-title">订购转化：{{query.startDay.substring(0,10)}} ～ {{query.endDay.substring(0,10)}}</h3>
                    <el-table
                        v-loading="loading"
                        :data="tableDataAvg" border
                        row-key="superiorId"
                        size="mini"
                        :highlight-current-row="true">


                        <el-table-column
                            fixed="left"
                            v-for="(col, index) in tableColumnsAvg"
                            :key="col.prop"
                            :prop="col.prop"
                            :label="col.label"
                            :fixed="index === 0 ? 'left' : false"
                            :min-width="index === 0 ? '220' : '130'"
                            :align="index === 0 ? 'left' : 'center'">
                            <template slot-scope="{ $index, row }">
                                <!-- 判断是否是最后一列（统计列） -->
                                <el-link
                                    v-if="col.prop !== '¶ 统计' && col.prop !== '产品名称'  "
                                    @click.native="handleCellClick(row, col)">
                                    {{ row[col.prop] }} %
                                </el-link>
                                <span v-else-if="col.prop === '¶ 统计'">{{ row[col.prop] }}%</span>
                                <span v-else :style="{ color: typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#') ? 'red' : '' }">
  {{
                                        typeof row[col.prop] === 'string' && row[col.prop].startsWith('red#')
                                            ? row[col.prop].substring(4)
                                            : row[col.prop]
                                    }}
</span>
                            </template>

                        </el-table-column>
                    </el-table>
                    <!-- 添加 5 个空白 div 撑开高度 -->
                    <div style="height: 20px;" v-for="n in 5" :key="n"></div>
                </div>
            </el-card>


            <el-drawer :title="intoData.loginName+'-'+intoData.goodsName+' - 进单环节分析'" :visible.sync="intoVisible"
                       direction="rtl" :append-to-body='true' height="60%">
                <div style="margin:0 30px">
                    <el-table :data="tableData2" border row-key="superiorId" v-loading="loadingDrawer"
                              :highlight-current-row="true">
                        <el-table-column prop="crossName" width="150" align="center" label="进单环节">
                            <template slot-scope="scope">
                                <b>{{ scope.row.crossName }}</b>
                            </template>
                        </el-table-column>
                        <el-table-column prop="crossNum" width="120" align="center" label="单量"></el-table-column>
                        <el-table-column prop="crossPre" width="120" align="center" label="占比">
                            <template slot-scope="scope">
                                <div v-if="scope.row.crossName !== '汇总'">
                                    <b>{{ scope.row.crossPre }}%</b>
                                </div>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>

            </el-drawer>

        </div>

    </div>

</template>

<script>
import bus from '../../common/bus';
import Schart from 'vue-schart';
import { dataStatistics, conversionAnalysisByProductAndMember } from '../../../api/orderStatistics/orderStatustucs';
import { fetchSelect } from '@/api/comGoods';
import { fetchSelect as fetchSelect3 } from '@/api/member';
import { fetchSelect as fetchSelect6 } from '@/view/channel/channel';

export default {
    name: 'dashboard',
    data() {
        return {

            queryByProduct: {
                startDay: '',
                endDay: '',
                goodsName: '',
                loginName: '',
                isDeduction: ''
            },
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 00:00:00';
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 00:00:00';
                        picker.$emit('pick', dayDate1);

                    }
                }, {
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 00:00:00';
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
            pickerOptions2: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 23:59:59';
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 23:59:59';
                        picker.$emit('pick', dayDate1);

                    }
                }, {
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if (date.month == 0) {
                            date.month = 12;
                            date.year = date.year - 1;
                        } else {
                            date.month = date.month + 1;
                        }
                        const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 23:59:59';
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
            select: { option: '' },
            select3: { option: '' },
            select6: { option: '' },
            loading: false,
            rawData: [],      // 后端返回的数据
            tableData: [],    // 用于展示的数据
            tableColumns: [],  // 列定义

            rawTData: [],      // 后端返回的数据
            tableTData: [],    // 用于展示的数据
            tableTColumns: [],  // 列定义

            rawDataAvg: [],      // 后端返回的数据
            tableDataAvg: [],    // 用于展示的数据
            tableColumnsAvg: [],  // 列定义
            query: {
                isDeduction: '0',
                dataType2: '1',
                startDay: '',
                endDay: '',
                status2: '',
                goodsId2: [],
                mids2: [],
                channelCode2: [],
                goodsId: [],
                channelCode: [],
                status: [],
                mids: []
            },


            // 表头数据
            tableHead1: [
                { prop: 'nowDay', label: '产品名称' },
                { prop: 'num1', label: '福建冠悦乐' },
                { prop: 'num2', label: '官洲趣盈' },
                { prop: 'num3', label: '流量果' },
                { prop: 'num4', label: '山东馨馨' },
                { prop: 'num5', label: '深圳秋葵' },
                { prop: 'nowCount', label: '¶ 统计' }
            ],
            // 表格数据
            tableData1: [
                {
                    goodsCode: '111',
                    goodsName: '河南移动-咪咕足球',
                    selectCount: '8632',
                    dataList: [{ mid: '1', loginName: '福建冠粤', mData: '10 - 3.01%' }, {
                        mid: '2',
                        loginName: '流浪狗',
                        mData: '21 - 3.01%'
                    }, { mid: '1', loginName: '天猫', mData: '10 - 3.01%' }]
                },
                {
                    goodsCode: '222',
                    goodsName: '河南电信-咪咕足球',
                    selectCount: '8632',
                    dataList: [{ mid: '1', loginName: '福建冠粤', mData: '12 - 3.01%' }, {
                        mid: '2',
                        loginName: '流浪狗',
                        mData: '10 - 3.01%'
                    }, { mid: '1', loginName: '天猫', mData: '10 - 3.01%' }]
                },
                {
                    goodsCode: '333',
                    goodsName: '官洲移动-咪咕足球',
                    selectCount: '8632',
                    dataList: [{ mid: '1', loginName: '福建冠粤', mData: '19 - 3.01%' }, {
                        mid: '2',
                        loginName: '流浪狗',
                        mData: '10 - 3.01%'
                    }, { mid: '1', loginName: '天猫', mData: '10 - 3.01%' }]
                }

            ],
            loadingDrawer: false,
            tableData2: [],
            intoVisible: false,
            intoData: { mid: '', loginName: '', goodsCode: '', goodsName: '' }

        };
    },
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('data-body3');
    },
    components: {
        Schart
    },
    mounted() {
        this.getSelect();
        this.getSelect3();
        this.getSelect6();
        this.initData();
        this.handleSearchDataBody3();
        // bus.$on('data-body3', row => {
        //     this.initData();
        //     this.handleSearchDataBody3();
        // });
    },
    computed: {}, 
    methods: {
        getSelect() {
            this.select = {};
            fetchSelect(this.select).then(res => {
                if (res.code == '200') {
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect3() {
            this.select3 = {};
            fetchSelect3(this.select3).then(res => {
                if (res.code == '200') {
                    this.$set(this.select3, 'option', res.data);
                }
            });
        },
        getSelect6() {
            this.select6 = {};
            fetchSelect6(this.select6).then(res => {
                if (res.code == '200') {
                    this.$set(this.select6, 'option', res.data);
                }
            });
        },
        initData() {
            this.query.status2 = ['9'];
            const nowDate = new Date();
            nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
            var date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth(),
                day: nowDate.getDate()
            };
            if (date.month == 0) {
                date.month = 12;
                date.year = date.year - 1;
            } else {
                date.month = date.month + 1;
            }
            const dayDate1 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 00:00:00';

            const dayDate2 = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day) + ' 23:59:59';
            this.$set(this.query, 'startDay', dayDate1.toString());
            this.$set(this.query, 'endDay', dayDate2.toString());
        },

        handleCellClick(row, data) {
            console.log('=============================row');
            console.log(row['产品名称']);
            console.log('=============================row');
            console.log('=============================data');
            console.log(data.prop);
            console.log('=============================data');
            let goodsName = typeof row['产品名称'] === 'string' && row['产品名称'].startsWith('red#')
                ? row['产品名称'].substring(4)
                : row['产品名称'];


            this.intoData.goodsCode = goodsName;
            this.intoData.goodsName = goodsName;
            this.intoData.mid = data.mid;
            this.intoData.loginName = data.prop;
            this.intoVisible = true;
            console.log('this.query===>>>' + this.query.startDay);
            console.log(this.query);

            this.queryByProduct.startDay = this.query.startDay;
            this.queryByProduct.endDay = this.query.endDay;
            this.queryByProduct.goodsName =goodsName;
            this.queryByProduct.loginName = data.prop;
            this.queryByProduct.isDeduction = this.query.isDeduction;
            this.loadingDrawer = true;
            conversionAnalysisByProductAndMember(this.queryByProduct).then(res => {
                if (res.code == 200) {
                    this.tableData2 = res.data.tableData;
                }
                this.loadingDrawer = false;
            });


        },
        customSummaryMethod({ columns, data }) {
            const sums = [];
            const avgData = this.rawDataAvg;

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '¶ 统计';
                    return;
                }

                const key = column.property;

                if (!key || key === '产品名称') {
                    sums[index] = '';
                    return;
                }

                const values = data.map(row => {
                    const val = row[key];
                    return typeof val === 'string' ? parseFloat(val.replace('%', '')) : val;
                });

                const total = values.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);

                let avgVal = avgData && avgData[$index] && avgData[$index][key] !== undefined
                    ? avgData[$index][key]
                    : '0.00';

                sums[index] = total > 0 || avgVal !== ''
                    ? `${total.toFixed(2)}% - ${avgVal}`
                    : '';
            });

            return sums;
        }
        ,
        addPercentageSign(row, column, cellValue) {
            // 如果是数字类型且需要添加百分号
            if (typeof cellValue === 'number' || !isNaN(cellValue)) {
                return `${cellValue}%`;
            }
            // 其他情况直接返回原值
            return cellValue;
        },
        handleArray(arr) {
            let arrCopy = '';
            if (arr != undefined && arr.length > 0) {
                arrCopy = arr.join();
                if (arrCopy.charAt(0) === ',') {
                    arrCopy = arrCopy.substring(1);
                }
                return arrCopy;
            }
            return null;
        },
        calculatePurchaseRates(dataOne, dataTwo) {
            // 初始化结果对象
            const result = {};

            // 获取所有列名（排除“产品名称”和“¶ 统计”）
            const columns = Object.keys(dataOne[0]).filter(key => key !== '产品名称' && key !== '¶ 统计');
            console.log('dataOne===>>>', dataOne);
            if (dataOne.length <= 1) {
                return;
            }
            console.log('dataTwo===>>>', dataTwo);
            // 遍历每一列
            columns.forEach(column => {
                let successnum = 0;
                let total = 0;

                // 遍历每一条数据
                for (let i = 0; i < dataTwo.length; i++) {

                    const successCount = dataOne[i][column];
                    console.log('column===>>>', column);
                    console.log('i===>>>', i);
                    const successRate = dataTwo[i][column];

                    if (typeof successCount === 'number' && typeof successRate === 'number' && successRate > 0) {
                        successnum += successCount;
                        total += successCount / (successRate / 100); // 根据成功率反推总订单数
                    }
                }

                // 计算订购率
                const purchaseRate = total > 0 ? (successnum / total) * 100 : 0;

                // 存入结果
                result[column] = {
                    successnum,
                    total,
                    purchaseRate: purchaseRate.toFixed(2)
                };
            });
            //这里是算全局的百分比数据
            let calculateOverallPurchaseRate1 = this.calculateOverallPurchaseRate(result);
            let length = dataOne.length;
            let dataTwoElement = dataOne[length - 1];

            columns.forEach(column => {
                let dataTwoElementElement = dataTwoElement[column];
                console.log('dataTwoElementElement>>>>', dataTwoElementElement);
                let resultElement = result[column];
                if (dataTwoElementElement != undefined && dataTwoElementElement != '') {
                    let dataTwoElementElementArr = dataTwoElementElement.split('-');
                    let dataTwoElementElementArr1 = dataTwoElementElementArr[0];
                    // dataTwoElement[column] = dataTwoElementElementArr1 + ' 丨 ' + resultElement.purchaseRate + '%';
                    dataTwoElement[column] =  resultElement.purchaseRate;
                }
            });
            let dataTwoElementElement1 = dataTwoElement['¶ 统计'];
            let split = dataTwoElementElement1.split('-');
            // dataTwoElement['¶ 统计'] = split[0] + ' 丨 ' + calculateOverallPurchaseRate1.overallRate + '%';
            dataTwoElement['¶ 统计'] =  calculateOverallPurchaseRate1.overallRate ;

            return result;
        }
        ,
        calculateOverallPurchaseRate(result) {
            let allSuccessnum = 0;
            let allTotal = 0;

            Object.values(result).forEach(item => {
                allSuccessnum += item.successnum;
                allTotal += item.total;
            });

            const overallRate = allTotal > 0 ? (allSuccessnum / allTotal) * 100 : 0;
            return {
                allSuccessnum,
                allTotal,
                overallRate: overallRate.toFixed(2)
            };
        },

        handleSearchDataBody3() {
            console.log('this.query===>>>' + this.query.startDay);
            console.log(this.query);
            this.query.status = this.handleArray(this.query.status2);
            this.query.goodsId = this.handleArray(this.query.goodsId2);
            this.query.mids = this.handleArray(this.query.mids2);
            this.query.channelCode = this.handleArray(this.query.channelCode2);
            let query2 = JSON.parse(JSON.stringify(this.query));
            query2.status2 = null;
            query2.goodsId2 = null;
            query2.mids2 = null;
            query2.channelCode2 = null;
            this.loading = true;
            dataStatistics(query2).then(res => {
                console.log('dataStatistics数据返回=============>>>' + res);
                if (res.code == 200) {
                    const result = res.data || {};

                    if (result){
                        let data = result.dataOne || [];
                        let data2 = result.dataTwo || [];
                        let data3 = result.dataThree || [];
                        if (data.length>0 &&data.length>0){

                            this.calculatePurchaseRates(data, data2);
                            const lastItem = data[data.length - 1];
                            data2.push(lastItem);

// 安全删除最后一个元素并创建一个新数组
                            const updatedData = data.slice(0, -1);

                            // data[data.length - 1] = null;
                            // 动态生成列
                            if (data.length > 0) {
                                this.rawData = updatedData;
                                this.tableData = updatedData;
                                const firstRow = updatedData[0];
                                this.tableColumns = Object.keys(firstRow).map(key => ({
                                    prop: key,
                                    label: key
                                }));


                                this.rawTData = data3;
                                this.tableTData = data3;
                                const firstTRow = data3[0];
                                this.tableTColumns = Object.keys(firstTRow).map(key => ({
                                    prop: key,
                                    label: key
                                }));


                                this.rawDataAvg = data2;
                                this.tableDataAvg = data2;

                                // 动态生成列
                                if (data2.length > 0) {
                                    const firstRow = data2[0];
                                    this.tableColumnsAvg = Object.keys(firstRow).map(key => ({
                                        prop: key,
                                        label: key
                                    }));
                                }
                                console.log('this.tableData===>>>' + this.tableDataAvg);
                                console.log('this.rawData===>>>' + this.rawDataAvg);



                            } else {
                                this.clearData();
                            }
                        }

                    }

                    console.log('this.tableData===>>>' + this.tableData);
                    console.log('this.rawData===>>>' + this.rawData);

                } else {
                    this.clearData();

                }
                this.loading = false;
            });
        },
        clearData() {
            console.log('clearData');
            this.rawData = null;
            this.tableData = null;
            this.tableColumns = null;

            this.rawTData = null;
            this.tableTData = null;
            this.tableTColumns = null;

            this.rawDataAvg = null;
            this.tableDataAvg = null;
            this.tableColumnsAvg = null;

            this.$nextTick(() => {
                // 再恢复为空数组，触发响应式更新
                this.rawData = [];
                this.tableData = [];
                this.tableColumns = [];

                this.rawTData = [];
                this.tableTData = [];
                this.tableTColumns = [];

                this.rawDataAvg = [];
                this.tableDataAvg = [];
                this.tableColumnsAvg = [];
            });

        }


    }
};
</script>


<style>
.panSelectMore {
    width: 99%;
    margin: 5px 0 20px 1%;
    text-align: left;
}

.table1, .table2 {
    margin: 0 1%;
    width: 98%;
}

.table2 {
    margin-top: 35px;
}

.table1 .cell {
    color: #777;
    font-weight: 900;
}

.el-table__row .cell {
    font-weight: 500;
}

.el-table {
    overflow: visible !important;
}
 

.el-drawer.rtl {
    width: 500px !important;
}
.table-title {
    text-align: center;
    font-size: 16px;
    color: #2793d5;
    font-weight: bold;
    margin: 15px 0;
    padding: 8px 16px;
    background-color: #f9f9f9;
    border-radius: 6px;
    display: inline-block;
    width: 100%;
}
</style>
 
